import React from "react";
import HeroSection from "../components/HeroSection";
import FeatureCard from "../components/FeatureCard";
import { Link } from "react-router-dom";
import { heroSections, industryFeatureCards } from "../constants/data.ts";

const Industries = () => {
  return (
    <main className="bg-background">
      {/* Hero Section */}
      <HeroSection {...heroSections.industries} />

      {/* Industries Grid */}
      <section className="py-16 md:py-24 px-outer">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {industryFeatureCards.map((industry, index) => (
              <FeatureCard key={index} {...industry} />
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-24 px-outer bg-gradient-to-r from-secondary to-blue-900">
        <div className="container mx-auto text-center text-white">
          <h2 className="font-rubik font-bold text-3xl md:text-4xl mb-4">
            Let's Explore Your Industry Needs
          </h2>
          <p className="font-rubik font-light text-lg mb-8 max-w-2xl mx-auto">
            Our experts are ready to discuss how we can serve your specific
            industry requirements.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact" className="btn-primary">
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Industries;
